module.exports = __webpack_public_path__ + "static/media/g-13.680714e0.jpg";